/**
 * Created with IntelliJ IDEA.
 * User: raml
 * Date: 3/20/13
 * Time: 10:46 AM
 */
define(function (require) {
    "use strict";

    //todo: change input to use textarea ui component

    var LE = require("app"),
        lpUtils = require("utils/lpUtils"),
        domUtilities = require("infra-util/DomUtilities"),
        template = require("connection-templates/chatTab/chatWindowInput.tmpl"),
        HtmlSanitizerUtils = require("HtmlSanitizerUtils"),
        ChatWindowInputView = {};

    LE.module("LEConnection", function (LEConnection, LE, Backbone, Marionette, $, _) {

        var MAX_EXPANSION_LINES = 8;

        ChatWindowInputView = Marionette.ItemView.extend({
            className: "chat-input-container chat-input-disabled",
            template: template,
            ui: {
                input: ".chat-text-input",
                sendButton: ".chat-send-button",
                chatInputRow: ".chat-input-row",
                buttonContainer: ".chat-send-button-container"
            },
            events: {
                "paste .chat-text-input": "_onPasteEvent",
                "keydown .chat-text-input": "_onChatInputKeyDown",
                "blur .chat-text-input": "_onChatInputBlur",
                "focus .chat-text-input": "_onChatInputFocus",
                "click .chat-send-button-container": "_onSendButtonClick"
            },

            initialize: function (options) {
                this._inputResizeProperties = {};
                this._chatVent = options.chatVent;
                this._bindEvents();
                this._defaultEmptyText = LE.translator.translate("LEConnection.chat.emptyChatInputField");
            },

            onRender: function () {
                this.ui.input.val(this._defaultEmptyText);

                setTimeout(_.bind(function () { // By setting timeout we ensure that the asynchronous code is done after current thread code is completed and this UI component is attached to the DOM, so we can get outerHeight
                    this._initInputResizeProps();
                }, this), 0);
            },

            _bindEvents: function () {
                this.listenTo(this.model, "change:chatActive", this._onChatActiveChange);
            },

            _initInputResizeProps: function () {

                var cssProps = this.ui.input.css(["lineHeight", "height", "font-size"]);
                var height = domUtilities.getPixelCount(cssProps.height);

                this._inputResizeProperties = {
                    maxHeight: this._getMaxInputHeight(cssProps),
                    lastHeight: height,
                    orgHeight: height,
                    lastValue: null
                };
            },

            _getMaxInputHeight: function (cssProps) {
                return (cssProps.lineHeight === "normal" ?
                    domUtilities.getPixelCount(cssProps["font-size"]) :
                    domUtilities.getPixelCount(cssProps.lineHeight)) * MAX_EXPANSION_LINES;
            },

            _onChatActiveChange: function (model, value) {

                if (this.getIsRendered()) {
                    this.$el.toggleClass("chat-input-disabled", !value);
                    this.$el.toggleClass("chat-input-active", value);

                    if (value) {
                        this.ui.input.removeAttr("disabled");

                        this._inputResizeProperties.lastHeight = this._inputResizeProperties.orgHeight;
                        this._inputResizeProperties.lastValue = null;

                        this._autoExpand(); //make sure auto expand recalculates to get the right height and if needed trigger the resize event so the content is also resized
                    }
                    else {
                        this.ui.input.attr("disabled", "disabled");
                    }
                }
            },

            _onSendButtonClick: function () {
                setTimeout(_.bind(function () {
                    this._submitChatLine();
                    this.ui.input.focus();
                }, this), 0);
            },

            _onChatInputFocus: function () {

                if (this._checkIsDefaultInput()) {
                    this.ui.input.val("");
                }
            },

            _onChatInputBlur: function () {

                setTimeout(_.bind(function () {

                    var inputText = this._getInputText();

                    if (inputText.length === 0) {
                        this.ui.input.val(this._defaultEmptyText);
                        this.$el.removeClass("input-has-text"); //this.ui.buttonContainer.removeClass("input-has-text");
                    }
                }, this), 0);
            },

            _onChatInputKeyDown: function (e) {

                setTimeout(_.bind(function () {
                    this._checkHasValue();
                    this._updateUserTyping();
                }, this), 0);

                var keyCode = lpUtils.getKeyCode(e);  // Getting the key code for the text input

                if (keyCode == 13) {//Check if it's the enter key and if there is any chat input

                    if (!e.shiftKey) {
                        setTimeout(_.bind(function () {
                            this._submitChatLine();
                        }, this), 0);

                        e.preventDefault(e);
                        return false;
                    }
                }
            },

            _onPasteEvent: function () {

                setTimeout(_.bind(function () {
                    this._updateUserTyping();
                }, this), 0);
            },

            _checkHasValue: function (text) {
                var hasValue = this._hasInputValue(text);

                this.$el.toggleClass("input-has-text", hasValue);

                if (!hasValue) {
                    this._inputResizeProperties.lastValue = null;   //reset the lastvalue for the resizing functionality
                }

                this._autoExpand();
            },

            _checkIsDefaultInput: function () {

                var inputText = this._getInputText();
                return (inputText === this._defaultEmptyText);
            },

            _hasInputValue: function (text) {
                var inputText = text || this._getInputText();
                return (inputText.length > 0 && inputText !== this._defaultEmptyText);
            },

            _getInputText: function () {
                return this.ui.input[0].value.replace(/\s\s*$/, "");
            },

            _updateUserTyping: function (stop) {

                var typing = stop ? false : this._hasInputValue();

                this.model.set("userTyping", typing); //update the visitor is typing status (true or false)
            },

            _submitChatLine: function () {

                var inputText = this._getInputText();

                inputText = HtmlSanitizerUtils.sanitizeHtml(inputText).cleanText;

                if (this._hasInputValue(inputText)) {

                    this.model.set("chatLine", inputText);
                    this._updateUserTyping(true);
                }

                this.ui.input.val("");
                this._checkHasValue();
            },

            _autoExpand: function () {

                var input = this.ui.input;
                var resizeProps = this._inputResizeProperties;
                var currentVal = input.val();

                if (resizeProps.lastValue !== currentVal) { //only resize on value changed

                    resizeProps.lastValue = currentVal;

                    input.css({"height": "auto", "overflow-y": "hidden"}); //taken from web agent, settings height=true makes textarea scrollheight calc ignore white spaces
                    var scrollHeight = input.prop("scrollHeight");
                    var newHeight;

                    if (scrollHeight !== resizeProps.lastHeight) {
                        newHeight = scrollHeight > resizeProps.maxHeight ? resizeProps.maxHeight : scrollHeight;

                        if (newHeight < resizeProps.orgHeight) {
                            newHeight = resizeProps.orgHeight;
                        }
                    }

                    var delta = (newHeight || resizeProps.lastHeight) - resizeProps.lastHeight;
                    newHeight = (resizeProps.lastHeight + delta);
                    var overflow = (scrollHeight > newHeight ? "auto" : "hidden");

                    input.css({"height": newHeight, "overflow-y": overflow}); //set the height and overflow-y of the input

                    if (delta) {
                        resizeProps.lastHeight = newHeight;
                        this._chatVent.trigger("cpChatUI:input:resize", {delta: delta});// raise event about resize so content view is also resized accordingly
                    }
                }
            }
        });
    });
    return ChatWindowInputView;
});
